module.exports = __webpack_public_path__ + "img/zap.5a481453.svg";